module.exports = __webpack_public_path__ + "svg/flags/Iran, Islamic Republic of.svg";